import React, {Component} from 'react';
import './searchBar.scss'
import axios from "axios";
import searcherIcon from "../../../Assets/icons/google_ad.svg";
import ProfileCard from "../profile-card/profile-card";


export default class searchBar extends Component < any, any> {
    state = {
        ShowSearch:false,
        KeyWord:'',
        searchTimer:10,
        loading:false,
        Data:[],
        DataProfile:null
    };
    constructor(props: any) {
        super(props);


        this.state = {
            ShowSearch:false,
            KeyWord:'',
            searchTimer:10,
            loading:false,
            Data:[],
            DataProfile:null
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e: any) {

        const { name, value } = e.target;
        this.setState({ [name]: value });


            clearTimeout(this.state.searchTimer);
            this.setState({ searchTimer:setTimeout(() => {
                    this.search();
                }, 500) });




    }
    search(){
        this.setState({ Data: [],loading:true});
        axios
            .get(`https://8i9s27h4vl.execute-api.us-west-2.amazonaws.com/dev/insta/autocomplete?query=${this.state.KeyWord}`)

            .then((response :any)=> {
                this.setState({ Data:response.data.users ,loading:false });
            })
            .catch(error => {
                this.setState({ Data: [],loading:false });
            });
        setTimeout(() => {
        }, 1000);

    }
    clearQuestion(){
        this.setState({ KeyWord: ''});
        this.setState({ ShowSearch: false });
    }
    setQuestion(question:any){
        this.setState({ KeyWord: question.user.username });
        this.setState({ loading:true});
        axios
            .post(`https://8i9s27h4vl.execute-api.us-west-2.amazonaws.com/dev/list/creator/item/`,{username:question.user.username,listName:''})
            .then((response :any)=> {
                this.setState({ DataProfile:response.data.profile ,loading:false });
                this.setState({ ShowSearch: false });
                this.setState({ loading:false});
            })
            .catch(error => {
                this.setState({ DataProfile: null,loading:false });
                this.setState({ ShowSearch: false });
            });
        setTimeout(() => {
        }, 1000);
        // this.props.history.push('/panel/chatbot/'+question.ProjectId+'/'+question.Id)
    }
    componentDidMount() {
    }
    render() {


        const {ShowSearch, KeyWord,Data,loading,DataProfile} = this.state;
    return (
      <div className="page-searchbar row">

          <div  className="row">
              <div className="col-md-2">
              </div>
              <div  className="col-md-8" style={{ zIndex: 1}}>
          <form  className=" mt-100 search-form" autoComplete={"off"} onBlur={()=>{
              setTimeout(() => {
                  this.setState({ ShowSearch: false });
              }, 500);



          }} >
          <input  value={KeyWord}  onChange={this.handleChange} onFocus={()=>{
              this.setState({ ShowSearch: true });
          }}  type="search" placeholder="Please Enter Instagram Account..." name="KeyWord" autoComplete={"off"}  />
          <a className="clear">
              {
                  loading ? (  <i className="progress color-blue">
                  </i>):(
                      (KeyWord ) ? ( <i className="mdi mdi-close color-red" onClick={()=>this.clearQuestion()}>
                      </i>):( <i className="mdi mdi-magnify  color-blue"  onClick={this.search}>
                      </i>)
                  )
              }

          </a>
              {Data.length>0 && KeyWord && ShowSearch && (  <ul>

                  {Data.map((item:any, index) =>
                      <li key={index+item.user.username}    onClick={(e) => {
                          this.setQuestion(item);
                          e.stopPropagation()
                      }}>
                          <a style={{display:'flex',justifyContent:'space-between'}}>
                              <div className="row" style={{margin:'auto'}}> <img  className="img" src={item.user.profile_pic_url} /> <p className="title">{item.user.full_name}</p></div>  <span className="project">{item.user.username}</span>
                          </a>
                      </li>
                  )}




              </ul>)}


    </form>
          </div>
              <div className="col-md-2">
              </div>
          </div>


              {
                  DataProfile ? (
                      <div  className="row " style={{ justifyContent: 'flex-end', margin: "auto" }} >
                          <div className="col-md-1">
                          </div>
                          <div className="col-md-10">
                              <ProfileCard data={DataProfile}>

                              </ProfileCard>
                          </div>

                          <div className="col-md-1">
                          </div>
                      </div>
                    ):(
                      <div  className="row " style={{ justifyContent: 'flex-end', margin: "auto" }} >
                      <div className="col-md-2">
                      </div>
                      <div className="col-md-5 px-25 py-30 " style={{  margin: "auto" }} >
                  <h3>
                      Please Enter Instagram Account...
                  </h3>

                  </div>
                  <div className="chatbot-back col-md-5 mt-40">
                  <img src={searcherIcon} alt="" />
                  </div>
                  <div className="col-md-2">
                  </div>
                      </div>
                  )
              }



    </div>
    )
  }
}
